(() => {
  const headingTags = new Set(["H1", "H2", "H3", "H4", "H5", "H6"]);

  const getText = (node) => node.textContent?.replace(/\s+/g, " ").trim() || "";

  const hasVisibleContent = (nodes) =>
    nodes.some((node) => getText(node) !== "");

  const captureInlineStyles = (root) => {
    const styles = new WeakMap();

    const capture = (node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;

      const style = node.getAttribute("style");
      if (style !== null) styles.set(node, style);

      Array.from(node.children).forEach(capture);
    };

    capture(root);
    return styles;
  };

  const restoreInlineStyles = (root, styles) => {
    const restore = (node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;

      if (styles.has(node)) {
        node.setAttribute("style", styles.get(node));
      }

      Array.from(node.children).forEach(restore);
    };

    restore(root);
  };

  const restoreInlineLabelStyles = (root) => {
    Array.from(root.querySelectorAll('p[style*="letter-spacing"]')).forEach(
      (node) => {
        if (!node.style.textTransform) {
          node.style.textTransform = "uppercase";
        }
      }
    );
  };

  const getContentSource = (content) => {
    const visibleNodes = Array.from(content.childNodes).filter((node) => {
      return node.nodeType !== Node.TEXT_NODE || getText(node) !== "";
    });

    if (
      visibleNodes.length === 1 &&
      visibleNodes[0].nodeType === Node.ELEMENT_NODE
    ) {
      return {
        node: visibleNodes[0],
        wrapper: visibleNodes[0],
      };
    }

    return {
      node: content,
      wrapper: null,
    };
  };

  const isSectionHeading = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;

    return headingTags.has(node.tagName);
  };

  const createSection = (headingNode, nodes, copyWrapper) => {
    const section = document.createElement("section");
    section.className = "policy-scroll-section";

    const sticky = document.createElement("div");
    sticky.className = "policy-scroll-sticky";

    if (headingNode) {
      headingNode.classList.add("policy-scroll-sticky-text");
      sticky.appendChild(headingNode);
    }

    const content = copyWrapper
      ? copyWrapper.cloneNode(false)
      : document.createElement("div");

    content.removeAttribute("id");
    content.classList.add("policy-scroll-copy");
    nodes.forEach((node) => content.appendChild(node));

    section.append(sticky, content);
    return section;
  };

  const initPolicyPage = () => {
    const container = document.querySelector(".shopify-policy__container");
    if (!container) return;

    const body = container.querySelector(".shopify-policy__body");
    const content = body?.querySelector(".rte") || body;
    if (!content || content.dataset.policyScrollEnhanced === "true") return;

    const inlineStyles = captureInlineStyles(content);
    const source = getContentSource(content);
    const nodes = Array.from(source.node.childNodes).filter((node) => {
      return node.nodeType !== Node.TEXT_NODE || getText(node) !== "";
    });

    const groups = [];
    let current = { headingNode: null, nodes: [] };

    nodes.forEach((node) => {
      const startsSection = isSectionHeading(node);

      if (startsSection) {
        if (hasVisibleContent(current.nodes)) groups.push(current);
        current = { headingNode: node, nodes: [] };
        return;
      }

      current.nodes.push(node);
    });

    if (hasVisibleContent(current.nodes)) groups.push(current);

    container.classList.add("policy-scroll-page");
    content.dataset.policyScrollEnhanced = "true";

    content.replaceChildren();
    groups.forEach((group) => {
      content.appendChild(
        createSection(group.headingNode, group.nodes, source.wrapper)
      );
    });
    restoreInlineStyles(content, inlineStyles);
    restoreInlineLabelStyles(content);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPolicyPage, {
      once: true,
    });
  } else {
    initPolicyPage();
  }
})();
